import CashoutTable from '../components/cashout/cashoutTable';
import CashoutWalletInfo from '../components/cashout/cashoutWalletInfo';

const CashOut = () => {
  return (
    <>
      <CashoutWalletInfo />
      <CashoutTable />
    </>
  );
};

export default CashOut;
